module.exports = __webpack_public_path__ + "img/plan-default-img-03.323da8d9.svg";